import PriceView from './PriceView'

export default PriceView
